import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getTranslatedText as t } from "../../_locale";
import { all_routes } from "../../feature-module/router/all_routes";
import { AppDispatch, RootState } from "../../core/redux/store";
import { utils } from "../../core/helpers/utils";
import { logoutUser } from "../../core/redux/userSlice";

const Header = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const location = useLocation();

    const { user } = useSelector((state: RootState) => state.user);
    const userAny = user as any;

    const [scrolled, setScrolled] = useState(false);
    const [isMegaMenu, setIsMegaMenu] = useState(false);
    const [avatar, setAvatar] = useState("");
    const [locale, setLocale] = useState("en");
    const [selectedClassroomId, setSelectedClassroomId] = useState("");


    // --- Handlers ---

    const handleClassroomChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const classroomId = e.target.value;
        // @ts-ignore
        setSelectedClassroomId(parseInt(classroomId));
    };

    const navigateToHome = () => {
        utils.deleteStore("selectedLevel");
        utils.deleteStore("selectedCategory");
        navigate(all_routes.home);
    };

    const handleLocaleChange = (locale: string) => {
        setLocale(locale);
        utils.setStore("locale", locale);
    };

    const onHandleMobileMenu = () => {
        document.getElementsByTagName("html")[0].classList.add("menu-opened");
    };

    const onhandleCloseMenu = () => {
        document.getElementsByTagName("html")[0].classList.remove("menu-opened");
    };

    // --- Effects ---

    useEffect(() => {
        if (userAny?.classrooms?.length > 0 && !selectedClassroomId) {
            if (utils.getStore("selectedCohort")){
                setSelectedClassroomId(JSON.parse(utils.getStore("selectedCohort")!).id)
                return;
            }
            setSelectedClassroomId(userAny.classrooms[0].id);
        }
    }, [userAny, selectedClassroomId]);

    useEffect(() => {
        setAvatar(utils.getAvatar(user));
    }, [user]);

    useEffect(() => {
        setLocale(utils.getStore("locale") || "en");
    }, []);

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 0);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        utils.setStore("selectedCohort", userAny?.classrooms?.find(
            (c: any) => c.id === parseInt(selectedClassroomId)
        ))
    }, [selectedClassroomId]);

    // --- Helper Components ---

    const studentNavDesktop = user && utils.isUserStudent(user) && (
        <ul className="main-nav d-none d-md-flex">
            <li className={`mx-3 ${location.pathname === all_routes.home ? "active" : ""}`}>
                <Link
                    to={all_routes.home}
                    onClick={(e) => {
                        e.preventDefault();
                        navigateToHome();
                    }}
                >
                    Home
                </Link>
            </li>
            <li className={`mx-3 ${location.pathname === all_routes.reports ? "active" : ""}`}>
                <Link to={all_routes.reports}>Reports</Link>
            </li>
        </ul>
    );

    const studentNavMobile = user && utils.isUserStudent(user) && (
        <ul className="main-nav d-md-none">
            <li className={`my-2 ${location.pathname === all_routes.home ? "active" : ""}`}>
                <Link
                    to={all_routes.home}
                    onClick={(e) => {
                        e.preventDefault();
                        navigateToHome();
                        onhandleCloseMenu();
                    }}
                >
                    Home
                </Link>
            </li>
            <li className={`my-2 ${location.pathname === all_routes.reports ? "active" : ""}`}>
                <Link to={all_routes.reports} onClick={onhandleCloseMenu}>
                    Reports
                </Link>
            </li>
        </ul>
    );

    const LetterAvatar = ({ name }: { name?: string }) => (
        <div
            className="letter-avatar"
            style={{
                width: "45px",       // Give it a fixed width
                height: "45px",      // Give it a fixed height
                minWidth: "45px",    // Ensure it stays this width
                flexShrink: 0,       // <-- THIS IS THE KEY FIX
                backgroundColor: "#47369a",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                fontSize: "18px",
            }}
        >
            {name?.charAt(0).toUpperCase() || "A"}
        </div>
    );

    return (
        <header className={`header-two ${scrolled ? "fixed" : ""}`}>
            <div className="container">
                <div className="header-nav align-items-center" style={{ minHeight: "70px" }}>

                    {/* Mobile Toggle & Logo */}
                    <div className="navbar-header">
                        <Link id="mobile_btn" to="#" onClick={onHandleMobileMenu}>
                            <span className="bar-icon">
                                <i className="isax isax-menu"></i>
                            </span>
                        </Link>
                        <div className="navbar-logo">
                            <span className="header-logo" onClick={navigateToHome}>
                                <img src="/assets/img/logo.png" className="logo" alt="Logo" />
                            </span>
                        </div>
                    </div>

                    {/* Navigation Menu Wrapper */}
                    <div className={`main-menu-wrapper ${isMegaMenu ? "active" : ""} flex-grow-1 justify-content-center`}>
                        <div className="menu-header">
                            <span className="menu-logo" onClick={navigateToHome}>
                                <img src="/assets/img/logo.png" className="img-fluid" alt="Logo" />
                            </span>
                            <Link id="menu_close" className="menu-close" to="#" onClick={onhandleCloseMenu}>
                                <i className="fas fa-times" />
                            </Link>
                        </div>

                        {studentNavDesktop || <div className="d-none d-md-block"></div>}

                        <div className="py-4 d-md-none">
                            {studentNavMobile}
                            <div className="d-md-none">
                                <span
                                    onClick={() => dispatch(logoutUser())}
                                    className="btn btn-secondary d-inline-flex align-items-center justify-content-center w-100 mt-2"
                                >
                                    <i className="isax isax-logout me-2" />
                                    {t("logout")}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Right Side: Profile Dropdown */}
                    <div className="header-btn d-flex align-items-center">
                        <div className="dropdown profile-dropdown">
                            <Link to="#" className="d-flex align-items-center" data-bs-toggle="dropdown">
                                <div className="me-2 d-none d-sm-flex flex-column text-end">
                                    <span style={{
                                        fontWeight: "600",
                                        fontSize: "14px",
                                        lineHeight: "1.2",
                                        color: "#333"
                                    }}>
                                        {userAny?.name || "ApiTwist"}
                                    </span>
                                    <span style={{
                                        fontSize: "11px",
                                        fontWeight: "400",
                                        color: "#777"
                                    }}>
                                        {/* @ts-ignore */}
                                        {selectedClassroomId && user?.classrooms!.find((x) => x.id === selectedClassroomId).name} {/* Replace with your dynamic subtitle */}
                                    </span>
                                </div>

                                {/* Avatar Container */}
                                <span className="avatar" style={{ position: 'relative', width: '45px', height: '45px', display: 'block' }}>
                                    {userAny?.avatar ? (
                                        <img src={avatar} alt="Img" className="img-fluid rounded-circle" />
                                    ) : (
                                        <LetterAvatar name={userAny?.name} />
                                    )}
                                </span>
                            </Link>

                            <div className="dropdown-menu dropdown-menu-end p-3" style={{ minWidth: '280px' }}>
                                <div className="profile-header">
                                    {/* Top Section: Avatar and Name/Email */}
                                    <div className="d-flex align-items-start mb-3">
                                        <div className="avatar me-3" style={{ flexShrink: 0, position: 'relative', width: '45px', height: '45px' }}>
                                            {userAny?.avatar ? (
                                                <img src={avatar} alt="Img" className="img-fluid rounded-circle" />
                                            ) : (
                                                <LetterAvatar name={userAny?.name} />
                                            )}
                                        </div>
                                        <div className="overflow-hidden">
                                            <h6 className="mb-0 text-truncate">{userAny?.name || "ApiTwist"}</h6>
                                            <p className="mb-0 text-muted small text-truncate">{userAny?.email}</p>
                                        </div>
                                    </div>

                                    {/* Classroom Selection: Full Width */}
                                    {userAny?.classrooms && userAny.classrooms.length > 0 && (
                                        <div className="classroom-select-wrapper mt-3">
                                            <label className="form-label small text-muted mb-1">Select Classroom</label>
                                            <select
                                                className="form-select form-select-sm w-100" // w-100 makes it full width
                                                value={selectedClassroomId}
                                                onChange={handleClassroomChange}
                                                style={{
                                                    cursor: 'pointer',
                                                    borderColor: '#47369a',
                                                    width: '100%'
                                                }}
                                            >
                                                {userAny.classrooms.map((classroom: any) => (
                                                    <option key={classroom.id} value={classroom.id}>
                                                        {classroom.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    )}
                                </div>

                                <div className="profile-footer mt-3 pt-3 border-top">
                                    <span
                                        onClick={() => dispatch(logoutUser())}
                                        className="btn btn-secondary d-inline-flex align-items-center justify-content-center w-100"
                                    >
                                        <i className="isax isax-logout me-2" />
                                        {t("logout")}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;